import React, { Component, createRef } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import Wizard from "./helpers/Wizard";
import * as actions from "../actions";
import Timeline from "./timeline";
import Step1 from "./ltc_steps/Step1";
import Step2 from "./ltc_steps/Step2";
import Step3 from "./ltc_steps/Step3";
import Step4 from "./ltc_steps/Step4";
import Step5 from "./ltc_steps/step5/Step5";
import LtcPdf from "../assets/pdf/AcadiaConnect_Service_Request_Digital_27AUG20.pdf";

class LtcForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitted: false,
            pdfUrl: false,
            ltcFormItems: null,
        };
    }

    onSubmit = async (values) => {
        const reactState = this;
        let url = "/";
        if (process.env.NODE_ENV === "development") {
            url = "http://localhost:8000/";
        }
        values.formType = "ltc";
        try {
            await Axios({
                method: "post",
                url: url + "api/generate_pdf",
                data: values,
                headers: {
                    "Content-type": "application/x-www-form-urlencoded",
                },
            }).then(function (res) {
                console.log("res", res);
                console.log(" res.data.file", res.data.file);
                reactState.setState({
                    ...reactState.state,
                    pdfUrl: url + res.data.file,
                    submitted: true,
                });
            });
        } catch (errors) {
            console.log("errors", errors);
        }
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({
            ltcFormItems: {
                [name]: value,
            },
        });
    };

    toTop = createRef();

    render() {
        const { submitted, pdfUrl } = this.state;
        const { formRef } = this.props;
        const buttonLabels = [
            "Resident information",
            "Insurance information",
            "Facility address",
            'Authorization and <br class="mobile"/>submission',
        ];
        // The steps timeline are ordered based on the following array
        const { innerWidth: viewportWidth, innerHeight: viewportHeight } =
            window;
        let steps = [
            "SERVICES&nbsp;NEEDED/<br>DIAGNOSIS",
            "RESIDENT INFORMATION",
            "INSURANCE INFORMATION",
            "FACILITY<br>ADDRESS",
            "AUTHORIZATION&nbsp;&<br>SUBMISSION",
        ];

        const formIdentifier = "LtcForm";

        return (
            <div className="acadia-form" id="ltc-form">
                <div className="container">
                    <div className="row spacer-small">&nbsp;</div>
                </div>
                <div className="container-fluid form-gradient">
                    <div className="container">
                        <Timeline steps={steps} />
                    </div>
                </div>
                <div className="container">
                    <div id="formTop" ref={this.toTop}>
                        <div className="row">
                            <div className="col-lg-8">
                                <Wizard
                                    onSubmit={this.onSubmit}
                                    buttonLabels={buttonLabels}
                                    formIdentifier={formIdentifier}
                                    noOfPages={5}
                                    toTop={this.toTop}
                                    submitted={submitted}
                                    formRef={formRef}
                                >
                                    <Wizard.Page>
                                        <Step1 />
                                    </Wizard.Page>
                                    <Wizard.Page>
                                        <Step2 />
                                    </Wizard.Page>
                                    <Wizard.Page>
                                        <Step3 />
                                    </Wizard.Page>
                                    <Wizard.Page>
                                        <Step4 />
                                    </Wizard.Page>
                                    <Wizard.Page>
                                        <Step5
                                            submitted={submitted}
                                            pdfUrl={pdfUrl}
                                        />
                                    </Wizard.Page>
                                </Wizard>
                            </div>
                            <div className="col-lg-4">
                                <div className="floating-cta">
                                    <div className="placeholder">
                                        <div class="row spacer-large mobile">
                                            &nbsp;
                                        </div>
                                        <div class="row spacer-large mobile">
                                            &nbsp;
                                        </div>
                                        <a href="tel:18447372223">
                                            <img src="/images/floating-cta-hcp-placeholder.png" />
                                        </a>
                                        <div>
                                            Monday&ndash;Friday, 8:00 am to 8:00 pm ET
                                        </div>
                                        <div class="row spacer-large mobile">
                                            &nbsp;
                                        </div>
                                        <div class="row spacer-large mobile">
                                            &nbsp;
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { currentStep } = state;
    return { currentStep: currentStep };
};

export default connect(mapStateToProps, actions)(LtcForm);
